'use strict';

var _ = require('underscore'),

    defaultOptions = {
        resolved: function() {}
    };

function Captcha(options) {
    if (!_.isObject(options)) {
        options = {};
    }

    _.defaults(options, defaultOptions);

    this.options = options;
}

Captcha.prototype = {
    solve: function(challenge) {
        var key = _.keys(challenge)[0],
            url = challenge[key].url,
            results = {};

        results[key] = url;

        this.options.resolved({
            type: 'captcha',
            results: results
        });
    }
};

module.exports = Captcha;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/captcha.js
 ** module id = 7
 ** module chunks = 0
 **/